import { render, staticRenderFns } from "./editClasses.vue?vue&type=template&id=2cf935a7&scoped=true&"
import script from "./editClasses.vue?vue&type=script&lang=js&"
export * from "./editClasses.vue?vue&type=script&lang=js&"
import style0 from "./editClasses.vue?vue&type=style&index=0&id=2cf935a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf935a7",
  null
  
)

export default component.exports